import { Accordion, Container } from "react-bootstrap";
import SectionHeader from "../../components/SectionHeader";
import img from "../../images/services-15.jpg";

function FestivalExhibitionInsurance() {

    return (
        <>

            <section className="service-page-bg">
                <SectionHeader title="Festival & Exhibition Insurance " PageLink="Festival & Exhibition Insurance " Image={img}></SectionHeader>
                <div className="service-page-main new-service-page-main">
                    <Container>
                        <div className="">
                            <h2>Festival & Exhibition Insurance</h2>
                            <p className="strong_text_p">Protect Your Event, Vendors, and Guests with Confidence  </p>
                            <p>
                                From lively street festivals and community fairs to elegant antique shows and trade exhibitions, these events bring people together to celebrate, connect, and share experiences. But with big crowds and so many moving parts, the unexpected can happen. An accident, a cancellation, or even minor damage can leave organizers and vendors facing financial loss.
                                <br />
                                Our <span className="strong_text">festival and exhibition insurance</span> is designed to give you peace of mind. Whether you are hosting a local craft fair or a large-scale trade show, we provide the protection you need so you can focus on creating a safe, successful, and enjoyable event.
                            </p>

                            <p className="strong_text_p">Why Organizers Trust Us </p>
                            <p>
                                We make it simple to protect your event. Every policy is tailored to the type of festival or exhibition you are planning, from
                                <span className="strong_text">arts and crafts fair insurance</span> to <span className="strong_text">trade show insurance.</span>
                                Vendors and exhibitors get the reassurance they need with <span className="strong_text">vendor insurance for festivals.</span>
                                At the same time, organizers and venues can count on our <span className="strong_text">public event liability insurance</span> to meet
                                requirements and keep everything secure. With us, you know your event is covered, and your guests can relax and enjoy the experience.
                            </p>

                            <p className="strong_text_p">What We Cover </p>
                            <ul className="list_style_disc">
                                <li><span className="strong_text">Enter your concert or event details</span> : Start by providing basic event information.</li>
                                <li><span className="strong_text">Get an instant quote</span> : See your pricing immediately—no waiting.</li>
                                <li><span className="strong_text">Buy your policy online</span> : Secure coverage in just a few clicks.</li>
                                <li><span className="strong_text">Download your Certificate of Insurance (COI) instantly</span> : Receive proof of coverage right away.</li>

                            </ul>
                            <p className="strong_text_p">How It Works</p>
                            <p>Getting <span className="strong_text">festival and exhibition insurance</span> is quick and easy: </p>
                            <ul className="list_style_disc">
                                <li>Enter your event details</li>
                                <li>Get an instant quote</li>
                                <li>Buy your policy online</li>
                                <li>Download your Certificate of Insurance (COI) instantly</li>

                            </ul>
                            <div className="mb-5">
                                <h2 className="">FAQs</h2>
                                <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Do I need insurance for a small local fair or market?</Accordion.Header>
                                        <Accordion.Body>
                                            Yes. Even small community events carry risks. Most venues require proof of public event liability insurance, and coverage ensures you won't face unexpected costs.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>Can vendors get their own insurance?</Accordion.Header>
                                        <Accordion.Body>
                                            Yes. We offer vendor insurance for festivals and markets, giving each booth or exhibitor protection for their space, equipment, and liability.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>Does insurance cover multi-day festivals or exhibitions?</Accordion.Header>
                                        <Accordion.Body>
                                            Yes. Our festival insurance and exhibition insurance can be extended to cover multiple days or recurring events.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>Is property damage to vendor booths covered?</Accordion.Header>
                                        <Accordion.Body>
                                            Yes, with the right policy. Trade show insurance or craft fair insurance can include protection for vendor property, booths, and displays.
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="4">
                                        <Accordion.Header>How fast can I get proof of insurance?</Accordion.Header>
                                        <Accordion.Body>
                                            Right away. Once you purchase your policy, you can download your Certificate of Insurance (COI) instantly and share it with venues, vendors, or partners.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                            <p className="strong_text_p">Your Event, Our Protection </p>
                            <p>From small fairs to large trade shows, we've got you covered. Start your policy online and have your COI ready instantly. </p>
                        </div>
                    </Container>
                </div>
            </section>
        </>
    );
}

export default FestivalExhibitionInsurance;
